// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import flatpickr from 'flatpickr';
import moment from 'moment';
import _ from 'lodash';
import I18n from '../i18n/I18n';

import Utils from '../utils/Utils';

/**
 * TODO: better readOnly
 */
export default class Calendar extends Component {

  static defaultProps = {
    readOnly: false,

    inline: true,

    maxDate: null,

    minDate: null
  };

  static propTypes = {
    defaultDate: PropTypes.object.isRequired, // moment object
    maxDate: PropTypes.object, // moment object
    minDate: PropTypes.object, // moment object
    onChange: PropTypes.func.isRequired, // param: moment object
    readOnly: PropTypes.bool,

    // Should we dislpay a button to open the calendar.
    inline: PropTypes.bool
  };

  id = Utils.generateUID();

  componentDidMount() {
    this.updateCalendarView();
  }

  componentDidUpdate(prevProps: Object) {
    this.updateCalendarView();
  }

  updateCalendarView() {
    // change the first day of the week to Monday
    flatpickr.init.prototype.l10n.firstDayOfWeek = 1;

    // Localize. See https://github.com/chmln/flatpickr/blob/gh-pages/src/flatpickr.l10n.fr.js

    flatpickr.init.prototype.l10n = I18n.localizeFlatpickr(flatpickr.init.prototype.l10n);
    const dateFormat = 'd-M-Y';

    // -- find default date

    const minDate = this.props.minDate;
    const maxDate = this.props.maxDate;

    flatpickr(`#${this.id}`, {
      dateFormat,
      defaultDate: this.props.defaultDate.toDate(),
      minDate: _.isNull(minDate) ? null : minDate.toDate(),
      maxDate: _.isNull(maxDate) ? null : maxDate.toDate(),
      onChange: this.onChange,
      disable: true
    });
  }

  onChange = (date: Object) => {
    if (!this.props.readOnly) {
      this.props.onChange(moment(date));
    }
  };

  render() {
    if (this.props.inline) {
      return (
        <div className="calendar">
          <input
            id={this.id}
            className="hidden"
            data-inline
          />
        </div>
      );
    } else {
      return (
        <div className="calendar-not-inline">
          <input
            className="form-control"
            id={this.id}
          />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/Calendar.js